import './Login.scss'
import React, {Component} from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from '../../helpers/withRouter'
import { Button, Col, Form, Icon, Input, notification, Row, Spin, Card, Typography, Divider } from 'antd'
import {changePasswordPromise, getAuthTokenPromise} from '../../promises'
import { resetPasswordPromise } from './promises'
import { authTokenSessionStorageSaverHelper } from '../../helpers'
import {Captcha, ModalChangePassword} from '../../layouts/Private/components'
import Logo from '../../layouts/commonComponent/components/Logo/Logo'
import { decodeAuthToken} from '../../helpers/decodeAuthToken'
import {SessionStorageService, LocalStorageService} from '../../services'

const { Title, Text } = Typography;


class Login extends Component {
  state = {
    username: '',
    password: '',
    isLoading: false,
    isRestore: false,
    captchaResponse: null,
    captchaSuccess: false,
    captchaKey: Math.random(),
    isModalChangePasswordVisible: false,
  }

  async handleOpenModalChangePassword() {
    this.setState({isModalChangePasswordVisible: true})
  }

  async handleCloseModalChangePassword() {
    this.setState({isModalChangePasswordVisible: false})
  }

  async handleSaveChangePassword(passwordCurrent, passwordNew, passwordNewConfirm) {
    await changePasswordPromise(passwordCurrent, passwordNew, passwordNewConfirm)

    this.setState({isModalChangePasswordVisible: false})
  }

  handleUsernameOnChange(username) {
    this.setState({ username })
  }

  handlePasswordOnChange(password) {
    this.setState({ password })
  }

  validateFields(fields) {
    const { form } = this.props

    return form.validateFields(fields, { force: true })
  }

  async handleSubmit(e) {
    e.preventDefault()

    await this.validateFields(['username', 'password'])

    this.setState({ isLoading: true })

    const { username, password } = this.state
    const { client } = this.props
    let loginUser = username
    if(client?.id) {
      loginUser = loginUser + '@' + client.id
    }
    
    const authToken = await getAuthTokenPromise(loginUser, password, this.props.t)

    this.setState({ isLoading: false })

    if (!authToken.error) {
      if (authToken && authToken.token) {
        await authTokenSessionStorageSaverHelper(authToken)

        const decodedToken = decodeAuthToken(authToken.token);
        SessionStorageService.create("userType",decodedToken.type);
        LocalStorageService.create("isPasswordBlocked",decodedToken.isPasswordBlocked);

        const {successHandler} = this.props
        await successHandler()
      }
    }
  }

  async handleCatpcha (success, response) {
    this.setState({captchaSuccess: success})
		if(response){
      this.setState({captchaResponse: response})
		}else{
      this.setState({captchaResponse: null})
      this.setState({captchaSuccess: false})
		}
	}

  renderFormItem = (formItem) => {
    const { getFieldDecorator } = this.props.form

    return (
      <Form.Item label={ formItem.label }>
        { getFieldDecorator(formItem.name, { rules: formItem.rules })(formItem.item) }
      </Form.Item>
    )
  }

  async handleSwitchToRestore(e) {
    e.preventDefault()

    await this.setState({ isRestore: true })
  }

  async handleSwitchToLogin(e) {
    e.preventDefault()

    await this.setState({ isRestore: false })
  }

  async handleRestorePassword(e) {
    e.preventDefault()

    const { t, client } = this.props

    this.handleCatpcha(false)
    this.setState({ captchaKey: Math.random() })
    const { username, captchaResponse } = this.state

    if(!captchaResponse) {
      notification.error({
        placement: 'topLeft',
        message: "Error",
        description: "Validacion no Superada"
      })
    }else {
      let loginUser = username
      if(client?.abreviado) {
        loginUser = loginUser + '@' + client.abreviado
      }

      this.validateFields(['username'])
      this.setState({ isLoading: true })

      const reset = await resetPasswordPromise(loginUser, captchaResponse)

      if (reset.success) {
        notification.success({
          message: t('messages.aml.successfulOperation'),
          description: t('messages.aml.checkYourEmail')
        })

        window.setTimeout(async () => {
          await this.setState({ isRestore: false })
        }, 4500)
      } else {
        notification.error({
          message: t('messages.aml.notifications.anErrorOcurred'),
          description: t('messages.aml.usernameDoesNotExists')
        })
      }
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { t, client } = this.props
    const { isLoading, isRestore, captchaKey, captchaSuccess, isModalChangePasswordVisible } = this.state

    return (
      <div className="login">
        <Spin spinning={isLoading} size="large" tip={isRestore ? t('messages.aml.login.sending') : t('messages.aml.login.loading')}>
          <Row type="flex" justify="center" align="middle" style={{ minHeight: "100vh", padding: "20px 0" }}>
            <Col xs={22} sm={18} md={14} lg={10} xl={8}>
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                {/* Logo del cliente */}
                {client?.id && (
                  <div style={{ marginBottom: 24 }}>
                    <Logo currentUser={{clientId: client.id}} isForm={false}/>
                  </div>
                )}
                
                {/* Icono y título principal */}
                <div style={{ marginBottom: 16 }}>
                  <Icon 
                    type={isRestore ? "mail" : "lock"} 
                    style={{ 
                      fontSize: 48, 
                      color: '#5b9bd5', 
                      marginBottom: 16,
                      display: 'block'
                    }} 
                  />
                  <Title level={2} style={{ margin: 0, color: 'rgba(0, 0, 0, .85)' }}>
                    {isRestore ? t('messages.aml.restorePassword') : 'AMLupdate v.2.0'}
                  </Title>
                  {!isRestore && (
                    <Text style={{ color: 'rgba(0, 0, 0, .65)', fontSize: 14 }}>
                      {t('messages.aml.login.subtitle')}
                    </Text>
                  )}
                  {isRestore && (
                    <Text style={{ color: 'rgba(0, 0, 0, .65)', fontSize: 14 }}>
                      {t('messages.aml.login.restoreSubtitle')}
                    </Text>
                  )}
                </div>
              </div>

              <Card 
                className="login-box-modern"
                bordered={false}
                style={{
                  background: 'rgba(255, 255, 255, .5)',
                  borderRadius: 12,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.18)'
                }}
              >
                <Form onSubmit={ isRestore ? this.handleRestorePassword.bind(this) : this.handleSubmit.bind(this) } className="login-form">
                  
                  {/* Campo Username */}
                  <div style={{ marginBottom: 24 }}>
                    {this.renderFormItem({
                      name: 'username',
                      rules: [{ required: true, message: t('messages.aml.dontForgetUsername') }],
                      item: (
                        <Input
                          disabled={ false }
                          onChange={ (e) => this.handleUsernameOnChange.bind(this)(e.target.value) }
                          prefix={ <Icon type="user" style={{ color: '#5b9bd5' }} /> }
                          placeholder={ t('messages.aml.username') }
                          size="large"
                          style={{
                            borderRadius: 8,
                            border: '1px solid #e8e8e8',
                            fontSize: 16
                          }}
                        />
                      )
                    })}
                  </div>

                  {/* Campo Password - solo si no es restore */}
                  { !isRestore && (
                    <div style={{ marginBottom: 24 }}>
                      {this.renderFormItem({
                        name: 'password',
                        rules: [{ required: true, message: t('messages.aml.dontForgetPassword') }],
                        item: (
                          <Input.Password
                            onChange={ (e) => this.handlePasswordOnChange.bind(this)(e.target.value) }
                            type="password"
                            autoComplete="off"
                            prefix={ <Icon type="lock" style={{ color: '#5b9bd5' }} /> }
                            placeholder={ t('messages.aml.password') }
                            size="large"
                            style={{
                              borderRadius: 8,
                              border: '1px solid #e8e8e8',
                              fontSize: 16
                            }}
                          />
                        )
                      })}
                    </div>
                  )}

                  {/* Captcha - solo en restore */}
                  { isRestore && (
                    <div className="captchaVerify" style={{padding:'20px 0', textAlign: 'center'}}>
                      <Captcha success={this.handleCatpcha.bind(this)} key={captchaKey}/>
                    </div>
                  )}

                  {/* Botón de envío */}
                  { (!isRestore || captchaSuccess) && (
                    <Button 
                      className="login-form-button-modern" 
                      type="primary" 
                      htmlType="submit"
                      size="large"
                      block
                      style={{
                        height: 48,
                        borderRadius: 8,
                        fontSize: 16,
                        fontWeight: 500,
                        background: '#5b9bd5',
                        borderColor: '#5b9bd5',
                        boxShadow: '0 2px 8px rgba(91, 155, 213, 0.2)'
                      }}
                    >
                      <Icon type={isRestore ? "mail" : "login"} style={{ marginRight: 8 }} />
                      { t('messages.aml.send') }
                    </Button>
                  )}

                  {/* Divider y enlaces */}
                  <div style={{ marginTop: 24, textAlign: 'center' }}>
                    <Divider style={{ margin: '24px 0 16px', borderColor: '#e8e8e8' }} />
                    
                    {!isRestore ? (
                      <a 
                        href='#' 
                        className="login-link-modern" 
                        onClick={ this.handleSwitchToRestore.bind(this) }
                        style={{ 
                          color: '#5b9bd5',
                          fontSize: 14,
                          textDecoration: 'none',
                          fontWeight: 500
                        }}
                      >
                        <Icon type="question-circle" style={{ marginRight: 4 }} />
                        { t('messages.aml.forgotYourPassword') }
                      </a> 
                    ) : (
                      <a 
                        href='#' 
                        className="login-link-modern" 
                        onClick={ this.handleSwitchToLogin.bind(this) }
                        style={{ 
                          color: '#5b9bd5',
                          fontSize: 14,
                          textDecoration: 'none',
                          fontWeight: 500
                        }}
                      >
                        <Icon type="arrow-left" style={{ marginRight: 4 }} />
                        { t('messages.aml.backToLogin') }
                      </a>
                    )}
                  </div>

                </Form>
              </Card>

              {/* Información de seguridad */}
              <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Text style={{ fontSize: 12, color: 'rgba(0, 0, 0, .45)' }}>
                  <Icon type="safety-certificate" style={{ marginRight: 4 }} />
                  {t('messages.aml.login.sslTls') }
                </Text>
              </div>

            </Col>
          </Row>
        </Spin>

        {isModalChangePasswordVisible &&
            <ModalChangePassword
                visible={true}
                onOk={this.handleSaveChangePassword.bind(this)}
                onCancel={this.handleCloseModalChangePassword.bind(this)}
                isForced
            />
        }
      </div>
    )
  }
}

const LoginForm = Form.create({ name: 'login_form' })(Login)


export default withTranslation()(withRouter(LoginForm))
